/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
// Limitless Imports
import DarkModeSwitch from "../dark-mode-switch/DarkModeSwitch";
import { useNavigation } from "../../hooks/navigation/NavigationContext";
import HelpMenu from "../help-menu/HelpMenu";
import SettingsMenu from "../settings-menu/SettingsMenu";
import { useExpertAnnouncementsContext, useExpertProfileContext } from "../../../expert";
import { POLICY_APP_INFO, POLICY_DARK_MODE } from "../../utils/CommonPolicyConstants";
import AppInfo from "../app-info/AppInfo";
import Notifications from "../notifications/Notifications";
// Modern Imports
import Box from "@limitless/modern/layout/Box";
import Grid from "@limitless/modern/layout/Grid";
import Breadcrumbs from "@limitless/modern/navigation/breadcrumbs/Breadcrumbs";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import Badge from "@limitless/modern/feedback/badge/Badge";
import Divider from "@limitless/modern/data-display/divider/Divider";
// Icon Imports
import BellIcon from "@limitless/icons/Bell";
const TopNav = ({
  helpDrawerAvailable,
  renderHeaderOptions,
  navItems
}) => {
  const {
    navigate,
    breadcrumb,
    setNavItems
  } = useNavigation();
  const {
    getNumOfUnreadAnnouncements
  } = useExpertAnnouncementsContext();
  const {
    canUserAccess,
    isDarkMode,
    toggleMode
  } = useExpertProfileContext();
  const isManager = canUserAccess(POLICY_APP_INFO);
  const hasDarModeAccess = canUserAccess(POLICY_DARK_MODE);
  const count = getNumOfUnreadAnnouncements();
  React.useEffect(() => setNavItems(navItems), []);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    alignItems: "center",
    sx: {
      padding: theme => `${theme.spacing(2)} ${theme.spacing(3)}`
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    items: breadcrumb
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "flex-end",
    alignItems: "center",
    sx: {
      gridColumnGap: theme => theme.spacing(2)
    }
  }, renderHeaderOptions(navigate), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      marginLeft: theme => theme.spacing(2)
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(Badge, {
      content: /*#__PURE__*/React.createElement(BellIcon, null),
      count: count,
      name: "announcements"
    }),
    label: "",
    onClick: () => {
      navigate("/announcements");
    }
  })), isManager && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(AppInfo, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(HelpMenu, {
    helpDrawerAvailable: helpDrawerAvailable
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(SettingsMenu, null)), hasDarModeAccess && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      maxWidth: 44
    }
  }, /*#__PURE__*/React.createElement(DarkModeSwitch, {
    checked: !isDarkMode,
    onCheckedChanged: toggleMode
  }))))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Divider, null))), /*#__PURE__*/React.createElement(Notifications, null));
};
TopNav.propTypes = {
  helpDrawerAvailable: PropTypes.bool,
  renderHeaderOptions: PropTypes.func,
  navItems: PropTypes.array
};
export default TopNav;